<template>
    <div class="card-body table mb-0">

        <PageHeader v-if="showHeading" title="Shipstation Orders" class="poppins fw-normal text-nowrap mt-2" />

        <GeneralTable :isProcessing="processing" :items="items" :fields="fields" :showEyeButton="true"
            :showActionButton="false" @showItem="openOrderModal" />

        <b-modal ref="orderModal" hide-footer title="Order Details" size="xl">
            <div v-if="selectedOrder" class="order-info">

                <div class="order-column">
                    <p><strong>Order #:</strong> {{ selectedOrder.orderNumber }}</p>
                    <p><strong>Status:</strong> {{ selectedOrder.orderStatus }}</p>
                    <p><strong>Service:</strong> {{ selectedOrder.serviceCode }}</p>
                    <p><strong>Order Date:</strong> {{ formatDate(selectedOrder.orderDate) }}</p>
                    <p><strong>Payment Date:</strong> {{ formatDate(selectedOrder.paymentDate) }}</p>
                    <p><strong>Ship Date:</strong> {{ selectedOrder.shipDate ?? '—' }}</p>
                    <p><strong>Hold Until:</strong> {{ selectedOrder.holdUntilDate ?? '—' }}</p>
                </div>

                <div class="order-column">
                    <h6>Billing</h6>
                    <p><strong>Name:</strong> {{ selectedOrder.billTo?.name }}</p>
                    <p><strong>Phone:</strong> {{ selectedOrder.billTo?.phone ?? '—' }}</p>
                    <p><strong>City:</strong> {{ selectedOrder.billTo?.city ?? '—' }}</p>
                </div>

                <div class="order-column">
                    <h6>Shipping</h6>
                    <p><strong>Name:</strong> {{ selectedOrder.shipTo?.name }}</p>
                    <p>
                        <strong>Address:</strong>
                        {{ selectedOrder.shipTo?.street1 }},
                        {{ selectedOrder.shipTo?.city }},
                        {{ selectedOrder.shipTo?.state }}
                        {{ selectedOrder.shipTo?.postalCode }}
                    </p>
                    <p><strong>Country:</strong> {{ selectedOrder.shipTo?.country }}</p>
                    <p><strong>Residential:</strong> {{ selectedOrder.shipTo?.residential ? 'Yes' : 'No' }}</p>
                </div>

                <div class="order-column full-width">
                    <h6>Items</h6>

                    <div v-for="item in selectedOrder.items" :key="item.orderItemId" class="order-item">
                        <p class="mb-1"><strong>{{ item.name }}</strong></p>
                        <small>
                            SKU: {{ item.sku }} |
                            Qty: {{ item.quantity }} |
                            Weight: {{ item.weight?.value }} {{ item.weight?.units }}
                        </small>
                    </div>
                </div>

            </div>
        </b-modal>

        <Pagination :pagination="paginationLinks" :showing="pagination" @paginator="fetchOrders" />

    </div>
</template>


<script>
import GeneralTable from "@/components/MagicTable/GeneralTable.vue";
import Pagination from "@/components/general/pagination.vue";
import PageHeader from "@/components/static/page-header";

export default {
    name: "UserShipments",

    components: {
        GeneralTable,
        Pagination,
        PageHeader
    },

    props: {
        user: {
            type: Object,
            required: true
        },
        showHeading:{
        type: Boolean,
        default:true
      }
    },

    data() {
        return {
            processing: false,

            items: [],
            selectedOrder: null,

            fields: [
                { key: "orderNumber", label: "Order #" },
                { key: "orderDateFormatted", label: "Order Date" },
                { key: "orderStatus", label: "Status" },
                { key: "shipToName", label: "Ship To" },
                { key: "serviceCode", label: "Service" },
                { key: "shipDate", label: "Ship Date" },
                { key: "action" }
            ],

            pagination: {},
            paginationLinks: []
        };
    },

    mounted() {
        this.fetchOrders();
    },

    methods: {
        fetchOrders({ url = "shipstation/list" } = {}) {
            this.processing = true;

            this.$axios
                .get(url, {
                    params: { user_id: this.user.id }
                })
                .then((response) => {
                    const payload = response.data.data;

                    this.pagination = {
                        from: payload.from,
                        to: payload.to,
                        total: payload.total
                    };

                    this.paginationLinks = payload.links;

                    this.items = payload.data.map(order => ({
                        ...order, // keep full object
                        id: order.id,
                        orderDateFormatted: this.formatDate(order.orderDate),
                        shipToName: order.shipTo?.name ?? '—'
                    }));

                    this.processing = false;
                })
                .catch(() => {
                    this.processing = false;
                });
        },

        openOrderModal(orderId) {
            const order = this.items.find(o => o.id === orderId);
            if (!order) return;

            this.selectedOrder = order;
            this.$refs.orderModal.show();
        },

        formatDate(date) {
            if (!date) return '—';
            return new Date(date).toLocaleString();
        }
    }
};
</script>


<style scoped>
.order-info {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
}

.order-column {
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 12px;
}

.full-width {
    grid-column: span 3;
}

.order-item {
    border-bottom: 1px dashed #ccc;
    padding-bottom: 6px;
    margin-bottom: 6px;
}

@media (max-width: 768px) {
    .order-info {
        grid-template-columns: 1fr;
    }

    .full-width {
        grid-column: span 1;
    }
}
</style>